/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_ConflictInputs */

const en_error_conflict = /** @type {(inputs: Error_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Someone changed this in the meantime. Reload and try again.`)
};

/**
* | output |
* | --- |
* | "Someone changed this in the meantime. Reload and try again." |
*
* @param {Error_ConflictInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_conflict = /** @type {((inputs?: Error_ConflictInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_ConflictInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_conflict(inputs)
});